// @ts-check

import * as _ from 'lodash-es'

export class UnsupportedEntryType extends Error {
  constructor(/** @type {EntryType | Pick<EntryResource, 'type'>} */ entry) {
    super(
      `Unsupported entry type: ${_.has(entry, 'type') ? entry.type : entry}`
    )
  }
}

export default UnsupportedEntryType
